<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-input v-model="keyword" placeholder="请输入药材名" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search mr10" @click="handleSearch">搜索</el-button>
                <el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-add"
                    @click="addEdit"
                >新增</el-button>
                <el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-add"
                    @click="addFile"
                >上传</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                v-loading="loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="药名" align="center"></el-table-column>
                <el-table-column prop="aliases" label="别名" align="center"></el-table-column>
                <el-table-column prop="spy" label="首字母简拼" align="center"></el-table-column>
                <el-table-column prop="unit" label="单位" align="center"></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.row)"
                        >修改</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="page_size"
                    :page-count="totalPages"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <el-dialog :visible.sync="editVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="ruleForm" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="药名：" prop="name">
                    <el-input
                     v-model="form.name" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="别名：" prop="aliases">
                    <el-input
                     v-model="form.aliases" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="单位：" prop="unit">
                    <el-input
                     v-model="form.unit" @input="onInput()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveEdit('ruleForm')">提 交</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="fileVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="fileForm" :model="file_form" label-width="60px">
                <el-form-item label="文件：">
                    <el-upload
                    class="avatar-uploader"
                    action
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    >
                        <p v-if="file_form.download_path" class="avatar">{{file_form.download_path}}</p>
                        <em v-show="!file_form.download_path && !uploading" class="el-icon-plus avatar-uploader-icon"></em>
                        <em class="el-icon-loading avatar-uploader-icon" v-show="uploading"></em>
                    </el-upload>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import http from '../../../api/dorisApiConfig'
export default {
    name: 'shmedicineslist',
    data() {
        return {
            keyword: '',
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            page_size: 10,
            pageTotal: 10,
            page_index: 10,
            loading: false,
            multipleSelection: [],
            editVisible: false,
            is_add: false,
            form: {},
            rules: {
                name: [{ required: true, message: "请填写药名", trigger: "blur" }],
                unit: [{ required: true, message: "请填写单位", trigger: "blur" }],
                spy: [{ required: true, message: "请填写首字母简拼", trigger: "blur" }]
            },
            file_form:{},
            fileVisible: false,
            uploading: false
        };
    },
    created() {
        this.getData();
    },
    methods: {
        formatDate(time){
            return new Date(time*1000).Format('YYYY-MM-DD hh:mm:ss');
        },
        getData() {
            let that = this;
            that.loading = true;
            let params = {
                page: that.currentPage,
                page_size: that.page_size
            }
            if(that.keyword){
                params['keyword'] = that.keyword;
            }
            http.get("admin/sh_medicines",{params: params}).then(function(res) {
                that.tableData = res.data.data.medicines;
                that.currentPage = res.data.data.current_page;
                that.totalPages = parseInt(res.data.data.total_pages);
                that.loading = false;
            });
        },
        //选择
        selectHandle(){
            this.currentPage = 1;
            this.getData();
        },
        // 触发搜索按钮
        handleSearch() {
            this.currentPage = 1;
            this.getData();
        },
        // 删除操作
        handleDelete(row) {
            let that = this;
            // 二次确认删除
            that.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                let params = {
                    medicine_id: row.medicine_id
                }
                http.delete("admin/sh_medicine", {params: params}).then(function(res) {
                    // console.log(res);
                    if (res.data.status_code == 200) {
                        that.$message.success('删除成功');
                        that.getData();
                    }else{
                        that.$message.error(res.data.msg);
                    }
                });
            })
            .catch(() => {});
        },
        onInput(){
            this.$forceUpdate();
        },
        // 编辑操作
        handleEdit(row) {
            this.form = {
                medicine_id: row.medicine_id,
                name: row.name,
                aliases: row.aliases,
                unit: row.unit
            }
            this.is_add = false;
            this.editVisible = true;
        },
        addFile(){
            this.file_form = {
                download_path: ''
            }
            this.fileVisible = true;
        },
        beforeAvatarUpload(file) {
            let that = this;
            const isPackage = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            if (isPackage) {
                var ossData = new FormData();
                var filename = file.name;
                ossData.append("work_path", "common/providerfile");
                ossData.append("bucket", "family-tcm");
                ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
                ossData.append("rewrite", "1");
                ossData.append("file_name", filename);
                ossData.append("file", file);
                that.uploading = true;
                http.post("admin/upload/sh_medicine", ossData).then(function(res) {
                    if (res.data.status_code == 200) {
                        that.downloadUrl = "common/providerfile/" + filename;
                        that.form.download_path = filename;
                        that.$message.success(`上传成功`);
                        that.getData();
                    }
                    that.uploading = false;
                    that.fileVisible = false;
                });
            } else if (!isPackage) {
                this.$message.error("上传文件不是文档");
            }
            return isPackage;
        },
        addEdit(){
            this.form = {
                name: '',
                aliases: '',
                unit: ''
            }
            this.is_add = true;
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit(formName) {
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        name: that.form.name,
                        aliases: that.form.aliases,
                        unit: that.form.unit
                    };
                    if(that.is_add){
                        http.post("admin/sh_medicine", params).then(function(res) {
                            // console.log(res);
                            if (res.data.status_code == 200) {
                                that.$message.success(`新增成功`);
                                that.getData();
                            }else{
                                that.$message.error(res.data.msg);
                            }
                        });
                    }else{
                        params['medicine_id'] = that.form.medicine_id;
                        http.put("admin/sh_medicine", params).then(function(res) {
                            // console.log(res);
                            if (res.data.status_code == 200) {
                                that.$message.success(`修改成功`);
                                that.getData();
                            }else{
                                that.$message.error(res.data.msg);
                            }
                        });
                    }
                    that.editVisible = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 分页导航
        handlePageChange(val) {
            this.currentPage = val;
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 180px;
}
.self-dialog-footer{
    display: block;
    text-align: center;
}
.avatar {
    height: 178px;
    display: block;
    max-width: 100%;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
</style>
